import React, { useMemo } from 'react';

import { Divider, Stack } from '@lyearn/ui';

import { parseVisibilitySettingsRestrictionConfig } from '../../utils';
import RestrictedVisibilitySettingsSelectedGroupsList from './components/RestrictedVisibilitySettingsSelectedGroupsList';
import RestrictedVisibilitySettingsSelectedUsersList from './components/RestrictedVisibilitySettingsSelectedUsersList';
import { RestrictedVisibilitySettingsSelectedListProps } from './types';

const RestrictedVisibilitySettingsSelectedList: React.FC<
  RestrictedVisibilitySettingsSelectedListProps
> = (props) => {
  const { value, onChange, contextualGroupsConfig, disabled, className = 'mt-16', mode } = props;

  const { groupIds, contextualGroups, userIds } = useMemo(
    () => parseVisibilitySettingsRestrictionConfig(value),
    [value],
  );

  if (!groupIds.length && !contextualGroups.length && !userIds.length) {
    return null;
  }

  return (
    <Stack className={className} direction="col">
      <RestrictedVisibilitySettingsSelectedUsersList
        disabled={disabled}
        value={value}
        onChange={onChange}
      />
      {userIds.length && groupIds.length && contextualGroups.length ? <Divider /> : null}
      <RestrictedVisibilitySettingsSelectedGroupsList
        contextualGroupsConfig={contextualGroupsConfig}
        disabled={disabled}
        mode={mode}
        value={value}
        onChange={onChange}
      />
    </Stack>
  );
};

export default RestrictedVisibilitySettingsSelectedList;
